import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[dragDrop]',
  standalone: true,
})
export class DragDropDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  dragDrop = output<File[]>();
  dragoverClass = input('dragover');

  @HostListener('drop', ['$event'])
  handleDrop(event: DragEvent) {
    event.preventDefault();
    const files = Array.from(event.dataTransfer?.files || []);
    this.dragDrop.emit(files);
    this.elementRef.nativeElement.classList.remove(this.dragoverClass());
  }

  @HostListener('dragover', ['$event'])
  handleDragOver(event: DragEvent) {
    event.preventDefault();
    const hasClass = this.elementRef.nativeElement.classList.contains(
      this.dragoverClass(),
    );
    if (!hasClass) {
      this.elementRef.nativeElement.classList.add(this.dragoverClass());
    }
    const dataTransfer = event.dataTransfer;
    if (dataTransfer) {
      dataTransfer.dropEffect = 'copy';
    }
  }

  @HostListener('dragleave')
  handleDragLeave() {
    this.elementRef.nativeElement.classList.remove(this.dragoverClass());
  }
}
